import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Meta Pixel Code
const metaPixelScript = document.createElement('script');
metaPixelScript.innerHTML = `
  !function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  fbq('init', '2056108180063139');
  fbq('track', 'PageView');
`;
document.head.appendChild(metaPixelScript);
// Add noscript tag for Facebook Pixel
const noscriptTag = document.createElement('noscript');
noscriptTag.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=2056108180063139&ev=PageView&noscript=1"/>`;
document.head.appendChild(noscriptTag);
// Add custom event tracking for CTA buttons
const trackingScript = document.createElement('script');
trackingScript.innerHTML = `
  document.addEventListener('DOMContentLoaded', function () {
    var btns = document.querySelectorAll('.cta-download');
    btns.forEach(function(btn) {
      btn.addEventListener('click', function(){
        fbq('trackCustom', 'CTA_Download_Click');
      });
    });
  });
`;
document.head.appendChild(trackingScript);
render(<App data-id="element-389" />, document.getElementById('root'));